import { Avatar, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import useModalImageStore from 'src/store/imageModal';

export default function MyAvatar({ src, alt, sx, modalImgSize, fallbackSrc = '/images/fallback.jpeg' }) {
  const [imgSrc, setImgSrc] = useState(src);
  const { onViewImage } = useModalImageStore();

  const handleImageError = () => {
    setImgSrc(fallbackSrc);
  };

  // update imgSrc whenever src changes
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return (
    <Tooltip title="مشاهده تصویر">
      <Avatar
        alt={alt}
        src={imgSrc || '/images/fallback.jpeg'}
        onError={handleImageError}
        sx={{ cursor: 'pointer', ...sx }}
        onClick={() => onViewImage({ imgSrc: imgSrc, imgSize: modalImgSize })}
      />
    </Tooltip>
  );
}
